// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'


import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '../static/css/global.css' /*引入公共样式*/
import '../static/css/global_all.css' /*引入公共样式*/

import ElementUI from 'element-ui'
import adminApi from './util/common.js';
import VueResource from 'vue-resource';


// 全局设置
ElementUI.Dialog.props.closeOnClickModal.default = false;

// 富文本样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import App from './App'
import router from './router'

import less from 'less'
Vue.use(less)

Vue.use(ElementUI);
Vue.use(VueResource);

// 请求拦截（配置发送请求的信息）-------------------
Vue.http.interceptors.push(function (request, next) {
    // 请求发送前加公共参数
    if (request.url != (this.adminApi.api_url + "/Login/login")) {
        // 获取user_id
        const user_id = sessionStorage.getItem('user_id') || '';
        const shop_sn = sessionStorage.getItem('shop_sn') || '';
        if (typeof request.body == 'string') {
            request.body = {};
        }
        if (user_id) {
            request.body.user_id = user_id;
        }
        if (shop_sn) {
            request.body.shop_sn = shop_sn;
        }
    }

    next((response) => {
        // 统一处理响应
        if (!response.ok || response.status >= 400) {
            // 网络错误或HTTP错误状态码
            // console.error('HTTP Error:', response);
            if (response.body) {
                const errorMsg = response.body.errmsg || response.body.message || response.body || '请求失败';
                // Vue.prototype.$message.error(errorMsg);
            } else {
                // Vue.prototype.$message.error('网络错误，请稍后重试');
            }
        } else if (response.body && response.body.status !== undefined && response.body.status !== 0) {
            // 业务逻辑错误（根据后端返回格式判断）
            // const errorMsg = response.body.errmsg || response.body.message || '请求失败';
            // Vue.prototype.$message.error(errorMsg);
            return response; // 仍然返回响应，让具体业务代码可以处理
        }
        return response;
    });

});


// 路由守卫
router.beforeEach((to, from, next) => {
    const whiteList = [
        '/Login',
        '/agreement',
        '/'
    ]
    let whiteIndex = whiteList.indexOf(to.path)
    if (whiteIndex !== -1) {
        return next()
    }
    // 获取token
    const token = sessionStorage.getItem('access-token');
    const shop_sn = sessionStorage.getItem('shop_sn');
    // 如果跳转的路由地址包含whiteList2的地址,则pass为true
    const whiteList2 = [
        '/edit_info',
        '/create_store/create_store_info',
        '/create_store/software_contract',
        '/create_store/create_store_pay'
    ]
    const pass = whiteList2.indexOf(to.path) !== -1
    // 如果token不存在，跳转到登录页；
    // 如果token存在店铺号不存在，说明登陆了，没有选择店铺，跳转到个人中心；
    if (!token){
        return next('/Login')
    }else if (token && to.path !== '/center' && !shop_sn && !pass) {
        return next('/center')
    }
    next()
})

//定义全局变量
Vue.prototype.adminApi = adminApi;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js